export default [
  {
    path: '/workArea',
    name: 'workArea',
    component: () => import(/* webpackChunkName: "workarea" */ './WorkArea')
  }, {
    path: '/workArea/admin',
    name: 'workAreaAdmin',
    component: () => import(/* webpackChunkName: "workarea" */ '@/components/home/workareaAdmin')
  }
]
